<section class="main-section">
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item"><a routerLink="/admin/adminDashboard/">Home</a></li>
            <li class="breadcrumb-item active" aria-current="page"> Stock Transfers</li>
        </ol>
    </nav>
    <div class="invalid-feedback d-block shift-invalid-text" [hidden]="!errorMessage">{{errorMessage}}</div>
    <div class="row align-items-center">
      <div class="col-8">
        <ul class="list-inline tab-list deskContent">
          <ng-container *ngFor="let om of stockTransferMainMenu">
            <li *ngIf="om.additional === 'N'" class="list-inline-item">
              <a (click)="populateTabData(om.tabClicked,om.orderStatus)" [ngClass]="{'active': tabClicked === om.tabClicked}">{{om.displayName}}</a></li>
          </ng-container>
          <li class="list-inline-item">
            <a data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">+ more</a>
            <div class="dropdown-menu dropdown-menu2">
              <ng-container *ngFor="let om of stockTransferMainMenu">
                <a *ngIf="om.additional === 'Y'" class="dropdown-item" (click)="populateTabData(om.tabClicked,om.orderStatus)" [ngClass]="{'active': tabClicked === om.tabClicked}">{{om.displayName}}</a>
              </ng-container>
            </div>
          </li>
        </ul>
        <select class="form-control MobileContent" id="use2r" [(ngModel)]="userDrop2" [ngModelOptions]="{standalone: true}" (change)="populate(userDrop2)" style="width: 140px;" required>
          <option *ngFor="let u of stockTransferMainMenu"  [ngValue]="u.orderStatus">{{u.displayName}}</option>
        </select>
      </div>
        <div class="col-4 text-right" [hidden]="tabClicked === 'received'">
            <button data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="btn btn-outline-primary btn-sm dropdown-toggle ml-2 d-none-mobile"   *ngIf="(checkedList?.length) && tabClicked !== 'all'">Actions</button>
          <a placement="bottom" ngbTooltip="Create" class="ml-2">
            <img src="assets/images/create.png" routerLink="/admin/stockTransferCreate"/>
          </a>
            <!--<button routerLink="/admin/stockTransferCreate" class="btn btn-outline-primary btn-sm ml-2">
        <svg class="bi bi-plus mr-2" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" d="M8 3.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H4a.5.5 0 0 1 0-1h3.5V4a.5.5 0 0 1 .5-.5z"></path>
          <path fill-rule="evenodd" d="M7.5 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H8.5V12a.5.5 0 0 1-1 0V8z"></path>
        </svg>Create
      </button>-->
            <div class="dropdown-menu dropdown-menu2  dropdown-menu-right"  *ngIf="(checkedList?.length) && tabClicked !== 'all'">
              <a *ngIf="tabClicked === 'submitted'" (click)="pickMultipleOrders(stockTransferList)"  [ngClass]="{'disabled':validToDisplay('Validated')}"  class="dropdown-item file btn shift-import">Pick the Order</a>
              <a *ngIf="tabClicked === 'submitted'" (click)="editStock(stockTransferList)" [ngClass]="{'disabled': checkedList?.length > 1}" class="dropdown-item file btn shift-import">Edit Order</a>
              <a *ngIf="tabClicked === 'submitted'" (click)="moveToHold(stockTransferList)" class="dropdown-item file btn shift-import">Move to Hold</a>
              <a *ngIf="tabClicked === 'submitted'" (click)="cancelOrder(stockTransferList)" class="dropdown-item file btn shift-import">Cancel Order</a>
              <a *ngIf="tabClicked === 'submitted'" [ngClass]="{'disabled':validToDisplay('Low Stock')}" (click)="moveToException(stockTransferList)" class="dropdown-item file btn shift-import">Move to Exception</a>
              <a *ngIf="tabClicked === 'pick'"  [ngClass]="{'disabled':validToDisplay('Ready to Pick')}"(click)="assignedPick(stockTransferList)" class="dropdown-item file btn shift-import">Assign Order Picker</a>
              <a *ngIf="tabClicked === 'pick'" (click)="selectGeneratePickSlip(stockTransferList)" class="dropdown-item file btn shift-import">Generate Pick Slip</a>
              <a *ngIf="tabClicked === 'pick'" (click)="moveToHold(stockTransferList)" class="dropdown-item file btn shift-import">Move to Hold</a>
              <a *ngIf="tabClicked === 'pick'" (click)="cancelOrder(stockTransferList)" class="dropdown-item file btn shift-import">Cancel Order</a>
              <a *ngIf="tabClicked === 'pick'" (click)="moveToException(stockTransferList)" class="dropdown-item file btn shift-import">Move to Exception</a>
              <a *ngIf="tabClicked === 'pack'" (click)="editStock(stockTransferList)" class="dropdown-item file btn shift-import">Pack Order</a>
              <a *ngIf="tabClicked === 'pack'" (click)="moveToHold(stockTransferList)" class="dropdown-item file btn shift-import">Move to Hold</a>
              <a *ngIf="tabClicked === 'pack'" (click)="cancelOrder(stockTransferList)" class="dropdown-item file btn shift-import">Cancel Order</a>
              <a *ngIf="tabClicked === 'pack'" (click)="moveToException(stockTransferList)" class="dropdown-item file btn shift-import">Move to Exception</a>
              <a *ngIf="tabClicked === 'readyToShip'" [ngClass]="{'disabled':validToDisplay('Carrier to be assigned')}" (click)="shipMultipleStockTransfer(stockTransferList)" class="dropdown-item file btn shift-import">Select the Carrier</a>
              <a *ngIf="tabClicked === 'readyToShip'" [ngClass]="{'disabled':validToDisplay('Generate Label')}"  (click)="generateShippingLabel(stockTransferList)" class="dropdown-item file btn shift-import">Generate Shipping Label</a>
              <a *ngIf="tabClicked === 'readyToShip'" [ngClass]="{'disabled':validToDisplay('Label Generated')}" (click)="selectAwaitingCarrier(stockTransferList)" class="dropdown-item file btn shift-import">Request for Pickup</a>
              <a *ngIf="tabClicked === 'readyToShip'" (click)="moveToHold(stockTransferList)" class="dropdown-item file btn shift-import">Move to Hold</a>
              <a *ngIf="tabClicked === 'readyToShip'" (click)="cancelOrder(stockTransferList)" class="dropdown-item file btn shift-import">Cancel Order</a>
              <a *ngIf="tabClicked === 'readyToShip'" (click)="moveToException(stockTransferList)" class="dropdown-item file btn shift-import">Move to Exception</a>
              <a *ngIf="tabClicked === 'shipped'|| tabClicked === 'awaitingCarrier'" (click)="shipMultipleOrders(stockTransferList)"[ngClass]="{'disabled':validToDisplay('Awaiting Carrier')}" class="dropdown-item file btn shift-import">Reassign Shipment</a>
              <a *ngIf="tabClicked === 'shipped'|| tabClicked === 'awaitingCarrier'" (click)="moveToInTransit(stockTransferList)" [ngClass]="{'disabled':validToDisplay('Awaiting Carrier')}" class="dropdown-item file btn shift-import">Shipped</a>
              <a *ngIf="tabClicked === 'shipped'|| tabClicked === 'awaitingCarrier'" [ngClass]="{'disabled':validToDisplay('shipped')}" (click)="selectArrived(stockTransferList)" class="dropdown-item file btn shift-import">Move to Arrived</a>
              <a *ngIf="tabClicked === 'shipped'|| tabClicked === 'awaitingCarrier'" (click)="returnOrders(stockTransferList)" class="dropdown-item file btn shift-import">Return Order</a>
              <a *ngIf="tabClicked === 'arrived'" (click)="editStock(stockTransferList)" class="dropdown-item file btn shift-import">Receive</a>
              <a *ngIf="tabClicked === 'partiallyReceived'" (click)="editStock(stockTransferList)" class="dropdown-item file btn shift-import">Receive</a>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <div class="inner-box d-none d-sm-block" [ngClass]="{'show-pagination':(!totalRecords || totalRecords<20)}">
                <table class="table" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
                    <thead>
                        <tr>
                            <th [hidden]="tabClicked === 'received' || tabClicked === 'all'">
                               <!-- <div class="form-checkbox">
                                    <input type="checkbox" id="all_items" [(ngModel)]="masterSelected" name="list_name" value="m1" (change)="checkUncheckAll()" />
                                    <label for="all_items"></label>
                                </div>-->
                            </th>
                            <th>Order Number</th>
                            <th>Ordered Date</th>
                            <th>Customer Name</th>
                            <th width="200px;">Source Warehouse</th>
                            <th width="200px;">Destination Warehouse</th>
                            <th width="150px;">Status</th>
                        </tr>
                    </thead>
                    <tbody class="table-body-custom">
                        <tr *ngFor="let s of stockTransferList">
                            <td [hidden]="tabClicked === 'received' || tabClicked === 'all'">
                                <div class="form-checkbox">
                                    <input type="checkbox" id="{{s.stockTransferHeaderId}}" [(ngModel)]="s.isSelected" name="list_name" (change)="selectShip(s)">
                                    <label for="{{s.stockTransferHeaderId}}"></label></div>
                            </td>
                          <td ><a routerLink="/admin/stockTransferView/{{s.stockTransferHeaderId}}">{{s.orderNumber}}</a></td>
<!--                            <td><a>{{s.orderNumber}}</a></td>-->
                            <td>{{s.orderedDate}}</td>
                            <td>{{s.ownerName}}</td>
                            <td width="200px;">{{s.warehouseName}}</td>
                            <td width="200px;">{{s.destWarehouseName}}</td>
                          <td>
                          <div class="text-truncate" width="150px">{{(s.orderStatus == 'SUBMITTED' ? (s.inStockStatus?'Validated':'Low Stock'): (s.orderStatus == 'PROCESSING' ? 'Processing' : (s.orderStatus == 'READY_TO_SHIP' ? 'Carrier to be assigned': (s.orderStatus == 'SHIPPED' ? 'Shipped':
                            (s.orderStatus == 'COMPLETED' ? 'Completed': (s.orderStatus == 'CANCELLED' ? 'Cancelled': (s.orderStatus == 'EXCEPTION' ? 'Exception': (s.orderStatus == 'TO_PICK' ? 'Ready to Pick': (s.orderStatus == 'PICK_ASSIGNED'
                            ? 'Picker Assigned': (s.orderStatus == 'TO_PACK' ? 'To Pack': (s.orderStatus == 'GENERATED' ? 'Generated': (s.orderStatus == 'AWAITING_CARRIER' ? 'Awaiting Carrier': (s.orderStatus == 'IN_TRANSIT' ? 'In Transit': (s.orderStatus
                            == 'GENERATE_LABEL' ? 'Generate Label': (s.orderStatus == 'LABEL_GENERATED' ? 'Label Generated': (s.orderStatus == 'TOTE_ASSIGNED' ? 'Tote Assigned': (s.orderStatus == 'DELIVERED' ? 'Delivered': (s.orderStatus == 'ON_HOLD'
                            ? 'On Hold': (s.orderStatus == 'PRODUCT_ALLOTTED' ? 'Product Allotted': (s.orderStatus == 'DRAFT' ? 'Draft ': s.orderStatus ))))))))))))))))))))}}
                          </div>
                          </td>
                            <!-- <td [hidden]="tabClicked === 'received'">
                 <a routerLink ="/admin/stockReceiveCreate/{{s.stockEntryHeaderId}}">
                   <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20.25 20.25">
                     <g id="pencil-black-tool-interface-symbol" transform="translate(-0.002)">
                       <g id="Group_1" data-name="Group 1" transform="translate(0.002)">
                         <path fill="#8A55BB" id="Path_1" data-name="Path 1" d="M0,483.655l2.127-.277L.279,481.528Z" transform="translate(-0.002 -463.405)"/>
                         <path fill="#8A55BB" id="Path_2" data-name="Path 2" d="M10.875,109.069l-.218,1.672,2.572,2.572,1.672-.218,11.381-11.381-4.026-4.026Z" transform="translate(-10.272 -93.448)"/>
                         <path fill="#8A55BB" id="Path_3" data-name="Path 3" d="M350.694.2A.7.7,0,0,0,350.2,0a.753.753,0,0,0-.532.223L346.92,2.97,350.946,7l2.747-2.747a.726.726,0,0,0,.02-1.026Z" transform="translate(-333.666)"/>
                       </g>
                     </g>
                   </svg>
                 </a>
               </td> -->
                        </tr>
                    </tbody>
                  <tfoot>
                  <tr *ngIf="stockTransferList?.length===0|| !stockTransferList?.length">
                    <td colspan="7" class="text-center">No matching records found</td>
                  </tr>
                  </tfoot>
                </table>
            </div>
            <div class="inner-box d-block d-sm-none">
                <table class="table tablesaw  tablesaw-stack" data-tablesaw-mode="stack">
                    <thead>
                    <tr>
                    <th>Order Number</th>
                    <th>Ordered Date</th>
                    <th>Customer Name</th>
                    <th width="200px;">Source Warehouse</th>
                    <th width="200px;">Destination Warehouse</th>
                    <th width="150px;">Status</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let s of stockTransferList">
                      <td><b class=" tablesaw-cell-label">Order Number</b>
                        <span class="tablesaw-cell-content"><a routerLink="/admin/stockTransferView/{{s.stockTransferHeaderId}}">{{s.orderNumber}}</a></span></td>
                      <!--                            <td><a>{{s.orderNumber}}</a></td>-->
                      <td><b class=" tablesaw-cell-label">Order Date</b>
                        <span class="tablesaw-cell-content">{{s.orderedDate}}</span></td>
                      <td><b class=" tablesaw-cell-label">Customer Name</b>
                        <span class="tablesaw-cell-content">{{s.ownerName}}</span></td>
                      <td><b class=" tablesaw-cell-label">Source Warehouse</b>
                        <span class="tablesaw-cell-content">{{s.warehouseName}}</span>
                      <td width="200px;"><b class=" tablesaw-cell-label">Destination Warehouse</b>
                      <span class="tablesaw-cell-content">{{s.destWarehouseName}}</span></td>
                      <td>
                        <b class=" tablesaw-cell-label">Status</b>
                        <span class="tablesaw-cell-content"><div class="text-truncate" width="150px">{{(s.orderStatus == 'SUBMITTED' ? (s.inStockStatus?'Validated':'Low Stock'): (s.orderStatus == 'PROCESSING' ? 'Processing' : (s.orderStatus == 'READY_TO_SHIP' ? 'Carrier to be assigned': (s.orderStatus == 'SHIPPED' ? 'Shipped':
                          (s.orderStatus == 'COMPLETED' ? 'Completed': (s.orderStatus == 'CANCELLED' ? 'Cancelled': (s.orderStatus == 'EXCEPTION' ? 'Exception': (s.orderStatus == 'TO_PICK' ? 'Ready to Pick': (s.orderStatus == 'PICK_ASSIGNED'
                          ? 'Picker Assigned': (s.orderStatus == 'TO_PACK' ? 'To Pack': (s.orderStatus == 'GENERATED' ? 'Generated': (s.orderStatus == 'AWAITING_CARRIER' ? 'Awaiting Carrier': (s.orderStatus == 'IN_TRANSIT' ? 'In Transit': (s.orderStatus
                          == 'GENERATE_LABEL' ? 'Generate Label': (s.orderStatus == 'LABEL_GENERATED' ? 'Label Generated': (s.orderStatus == 'TOTE_ASSIGNED' ? 'Tote Assigned': (s.orderStatus == 'DELIVERED' ? 'Delivered': (s.orderStatus == 'ON_HOLD'
                          ? 'On Hold': (s.orderStatus == 'PRODUCT_ALLOTTED' ? 'Product Allotted': (s.orderStatus == 'DRAFT' ? 'Draft ': s.orderStatus ))))))))))))))))))))}}
                        </div>
                        </span>
                      </td>
                      <!-- <td [hidden]="tabClicked === 'received'">
           <a routerLink ="/admin/stockReceiveCreate/{{s.stockEntryHeaderId}}">
             <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20.25 20.25">
               <g id="pencil-black-tool-interface-symbol" transform="translate(-0.002)">
                 <g id="Group_1" data-name="Group 1" transform="translate(0.002)">
                   <path fill="#8A55BB" id="Path_1" data-name="Path 1" d="M0,483.655l2.127-.277L.279,481.528Z" transform="translate(-0.002 -463.405)"/>
                   <path fill="#8A55BB" id="Path_2" data-name="Path 2" d="M10.875,109.069l-.218,1.672,2.572,2.572,1.672-.218,11.381-11.381-4.026-4.026Z" transform="translate(-10.272 -93.448)"/>
                   <path fill="#8A55BB" id="Path_3" data-name="Path 3" d="M350.694.2A.7.7,0,0,0,350.2,0a.753.753,0,0,0-.532.223L346.92,2.97,350.946,7l2.747-2.747a.726.726,0,0,0,.02-1.026Z" transform="translate(-333.666)"/>
                 </g>
               </g>
             </svg>
           </a>
         </td> -->
                    </tr>



                    </tbody>
                </table>
            </div>
        </div>
    </div>
</section>

<!--pickslippoup-->
<div [ngStyle]="{'display': pickSlipPopUp =='Y'? 'block' : 'none'}" style="overflow-y:auto" [ngClass]="{'modal': pickSlipPopUp == 'Y'}" class="modal" id="pickSlipPopUp2" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog  modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <button type="button" class="close" (click)="closePickSlipPop()" aria-label="Close">
          <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
            <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
              <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none" stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none" stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <div class="row mt-3">
          <div class="col">
            <div class="inner-box">


              <div class="row">
                <div class="col-md-4"  id="readers">
                  <label class="d-block"><b>Readers</b></label>
                </div>

                <div class="col-md-8 text-right">
                  <label class="d-block"><b>Pick List</b></label>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">

                  <address class="ml-2">
                    <label><b>{{modalPickLine.warehouseName}}</b></label>
                    <label class="d-block">{{modalPickLine.warehouseAddressText}}</label>
                  </address>
                </div>

                <div class="col-md-8 text-right">
                  <address class="ml-2">
                    <label class="d-block"><u>Order Number : {{modalPickLine.orderNumber}}</u></label>

                  </address>
                </div>
              </div>



              <div class="row">
                <div class="col-md-12">
                </div>
              </div>

              <table class="table">
                <tr>
                  <th>SKU</th>
                  <th>Product Name</th>
                  <th>Ordered Quantity</th>
                  <th>Bin Location</th>
                </tr>
                <tr *ngFor="let l of modalPickLine?.pickSlipData">
                  <td>{{l.sku|uppercase}}</td>
                  <td>{{l.productName|titlecase}}</td>
                  <td>{{l.quantity}}</td>
                  <td>{{l.binLocation}}</td>


                </tr>
              </table>

            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</div>

<div [ngStyle]="{'display': popUpAssign =='Y'? 'block' : 'none'}" style="overflow-y:auto" [ngClass]="{'modal': popUpAssign == 'Y'}" class="modal" id="popUpAssign" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog  modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <h5 class="modal-title w-100" id="exampleDriverModalPreviewLabel">Assign Order</h5>
        <div id="errorMessage" class="invalid-feedback d-block" [hidden]="!errorMessage">{{errorMessage}}</div>
        <button type="button" class="close" (click)="closePopUp()" aria-label="Close">
          <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
            <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
              <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none" stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none" stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>
          <div class="row mt-3">
            <div class="col">
              <div class="inner-box">
                <div class="col">
                  <label for="user">Select Resource</label>
                  <select class="form-control" id="user" [(ngModel)]="userDrop" [ngModelOptions]="{standalone: true}" required>
                    <option *ngFor="let u of userList" [ngValue]="u.id">{{u.firstName}}</option>
                  </select>
                </div>
                <div id="statusText1" class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText1">{{statusText1}}</div>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-12 text-right">
              <button type="submit" class="btn btn-orange ml-1" (click)="submitAssign()" id="assignResource">Assign</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<div [ngStyle]="{'display': popUpGenerate =='Y'? 'block' : 'none'}" style="overflow-y:auto" [ngClass]="{'modal': popUpGenerate == 'Y'}" class="modal" id="popUpGenerate" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog snk-modal-dialog modal-fluid modal-dialog-scrollable" role="document">
    <div class="snk-modal-content modal-content">
      <div class="snk-modal-header modal-header text-center">
        <h5 class="modal-title w-100" id="exampleModalPreviewLabel3">Shipping label</h5>
        <button type="button" class="close" (click)="closePopUpGenerate()" aria-label="Close">
          <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
            <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
              <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none" stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none" stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>
          <div class="row mt-3">
            <!--<div class="col-md-4">
  <img class="shift-uploaded-img shift-image" src="{{imageUrl !=null ? imageUrl : 'https://shift-images.s3.ap-south-1.amazonaws.com/Img-20-02-2020-19-51-56default-product.png'}}" width="250" height="200"/>
</div>-->
            <div class="col-md-12 text-right">
              <button class="btn btn-cancel" type="button" data-dismiss="modal" aria-label="Close" id="close">Close</button>
              <button type="submit" class="btn btn-orange ml-2" id="print">Print</button>
            </div>
          </div>
          <div>
            <div class="row mt-3" *ngFor="let n of noOfBoxesArray">
              <div class="col">
                <div class="inner-box">

                  <div class="row">
                    <div class="col-md-12 text-right">
                      <label>Print Copy : {{grant?.printCopy | titlecase}}</label>
                    </div>
                  </div>
                  `
                  <div class="row">
                    <div class="col-md-8">
                      <h2 class="text-body mb-3"><b>From: {{grant?.warehouseName}}</b></h2>
                      <label class="text-body"><b>{{grant?.ownerPhone}}</b></label><br>
                      <label class="text-body"><b>{{grant?.warehouseAddressText}}</b></label><br>
                      <hr class="border border-dark">
                      <h2 class="text-body mb-3"><b>To:</b></h2>
                      <label class="text-body"><b>{{grant?.contactName || grant?.destWarehouseName}}</b></label><br>
                      <label class="text-body"><b>{{grant?.contactAddressText}}</b></label>

                    </div>
                    <div class="col-md-4 text-dark-right">
                      <qrcode [qrdata]="myAngularxQrCode" [width]="256" [errorCorrectionLevel]="'M'"></qrcode>
                    </div>
                  </div>



                  <div class="row">
                    <div class="col-md-12">
                      <h2 class="text-black mb-3">Box Details</h2>
                    </div>
                  </div>

                  <table class="table">
                    <tr>
                      <th>Box#</th>
                      <th>No. of Boxes</th>
                      <th>W x L x H</th>
                      <th>Weight</th>
                    </tr>
                    <ng-container *ngFor="let g of grant?.orderLinesList">
                      <tr *ngFor="let p of g?.packingConfigList">
                        <td>{{1}}</td>
                        <td>{{p.noOfBoxes}}</td>
                        <td>{{p.width}} x {{p.length}} x {{p.height}}</td>
                        <td>{{p.weight}}</td>
                      </tr>
                    </ng-container>
                  </table>
                </div>
              </div>
            </div>
          </div>

        </form>
      </div>
    </div>
  </div>
</div>
<div [ngStyle]="{'display': popUpArrived =='Y'? 'block' : 'none'}" style="overflow-y:auto" [ngClass]="{'modal': popUpArrived == 'Y'}" class="modal" id="popUpArrived" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog  modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <h5 class="modal-title w-100" id="exampleDriverModalPreviewLabel1">Assign Order Id</h5>
        <button type="button" class="close" (click)="closePopUpForArrived()" aria-label="Close">
          <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
            <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
              <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none" stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none" stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>
          <div class="row mt-3">
            <div class="col">
              <div class="inner-box">
                <div class="col">
                  <div class="form-group  mt-2" id="assignTote">
                    <label class="control-label" for="assignedId">Assigned Id</label>
                    <input type="text" id="assignedId" [(ngModel)]="assignedId" class="form-control" [ngModelOptions]="{standalone: true}" required>
                  </div>
                  <div id="assignIdError" class="invalid-feedback d-block shift-invalid-login" [hidden]="!assignIdError">{{assignIdError}}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col-md-12 text-right" id="assign">
              <button type="submit" class="btn btn-orange ml-1" (click)="arrived()">Assign</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
